<template>
  <div class="range">
    <div class="range__input" :class="{ 'range__input--active': active }">
      <input
        type="range"
        step="100"
        :min="min"
        :max="max"
        :value="valueNumber"
        :style="`background-size: ${rangeBgSize}`"
        @input="onInput($event.target.value)"
        @pointerdown="active = true"
        @pointerup="active = false"
      />
    </div>
    <div class="range__count">
      <span @click="onInput(min)" :class="{ minmax: valueNumber === min, error: error === 'min' }">
        {{ minValueDisplay }}
      </span>
      <span @click="onInput(max)" :class="{ minmax: valueNumber === max, error: error === 'max' }">
        {{ maxValueDisplay }}
      </span>
    </div>
  </div>
</template>

<script>
const valueFormatter = new Intl.NumberFormat()

export default {
  name: 'RangeInput',
  props: {
    value: { type: [Number, String] },
    min: { type: Number },
    max: { type: Number },
    error: { type: String, default: null }
  },
  data: () => ({
    active: false
  }),
  computed: {
    minValueDisplay () {
      return `${valueFormatter.format(this.min)}`
    },
    maxValueDisplay () {
      return `${valueFormatter.format(this.max)}`
    },
    rangeBgSize () {
      // rtl numerator (this.max - this.value)
      const bgValue = ((this.value - this.min) * 100) / (this.max - this.min)
      return `${bgValue > 0 ? bgValue : 0}% 100%`
    },
    valueNumber () {
      return +this.value
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
@mixin slider-thumb {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #ffffff;
  border: 2px solid #52ab35;
  cursor: grab;
  transition: all 0.3s ease-in-out;
  -webkit-appearance: none;
}

@mixin slider-thumb-hover {
  box-shadow: 0px 7px 12px rgba(33, 14, 86, 0.16);
  height: 24px;
  width: 24px;
}

@mixin slider-thumb-focus {
  background: #52ab35;
  border: 2px solid #52ab35;
}

@mixin slider-track {
  -webkit-appearance: none;
  box-shadow: none;
  border: none;
  background: transparent;
}

.range {
  width: 100%;
  max-width: 416px;
  margin: 0 auto;
  direction: ltr;

  &__input {
    input[type='range'] {
      -webkit-appearance: none;
      height: 8px;
      width: 100%;
      background: rgba(82, 108, 130, 0.1);
      border-radius: 19px;
      border-radius: 5px;
      background-image: linear-gradient(#65d840, #65d840);
      background-repeat: no-repeat;

      &::-webkit-slider-thumb {
        @include slider-thumb;
        position: relative;
      }

      &::-moz-range-thumb {
        @include slider-thumb;
      }

      &::-ms-thumb {
        @include slider-thumb;
      }

      &::-webkit-slider-thumb:hover {
        @include slider-thumb-hover;
      }
      &::-moz-range-thumb:hover {
        @include slider-thumb-hover;
      }
      &::-ms-thumb:hover {
        @include slider-thumb-hover;
      }

      &::webkit-slider-thumb:focus {
        @include slider-thumb-focus;
        cursor: grabbing;
      }
      &::-moz-range-thumb:focus {
        @include slider-thumb-focus;
      }
      &::-ms-thumb:focus {
        @include slider-thumb-focus;
      }

      &::-webkit-slider-runnable-track {
        @include slider-track;
      }
      &::-moz-range-track {
        @include slider-track;
      }
      &::-ms-track {
        @include slider-track;
      }
    }

    &--active {
      input[type='range'] {
        &::-webkit-slider-thumb {
          background: #52ab35;
        }

        &::-moz-range-thumb {
          background: #52ab35;
        }

        &::-ms-thumb {
          background: #52ab35;
        }
      }
    }
  }
  &__count {
    font-weight: 400;
    margin-top: 6px;
    font-size: 14px;
    line-height: 24px;
    color: rgba(82, 108, 130, 0.8);
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    span {
      transition: color .3s ease;
      &.minmax {
        color: #1c1c1c;
      }
      &.error {
        color: #f94c27;
        font-weight: 600;
      }
    }
  }
}
</style>
